import {MembersPageState} from '../types/state'

export const getExpandedEvents = (state: MembersPageState) => state.expandedEvents
